export enum DisableNotificationsReasons {
  CarChanged = 'CAR_CHANGED',
  NoCar = 'NO_CAR',
}
